export function FolderSharedIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="42"
      height="32"
      viewBox="0 0 42 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M1.22392e-06 4C1.22392e-06 1.79086 1.79086 0 4 0H11.3733C12.2911 0 13.1725 0.358887 13.8293 1C14.486 1.64111 15.3674 2 16.2852 2H38C40.2091 2 42 3.79086 42 6V28C42 30.2091 40.2091 32 38 32H4C1.79086 32 1.22392e-06 30.2091 1.22392e-06 28V4Z"
        fill="#60A5FA"
      />
      <path
        d="M1.22392e-06 28V4C1.22392e-06 1.79086 1.79086 0 4 0H11.3733C12.2336 0 13.0618 0.315337 13.7031 0.882812L13.9551 1.11719C14.5964 1.68475 15.4249 1.99998 16.2852 2H38C40.2091 2 42 3.79086 42 6V28C42 30.2091 40.2091 32 38 32V31C39.6569 31 41 29.6569 41 28V6C41 4.34315 39.6569 3 38 3H16.2852C15.1064 2.99998 13.9744 2.53915 13.1309 1.71582C12.6609 1.25706 12.0298 1 11.373 1H4C2.34315 1 1 2.34315 1 4V28C1 29.6569 2.34315 31 4 31L4 32L3.79395 31.9951C1.68056 31.8879 1.22392e-06 30.14 1.22392e-06 28ZM38 31V32H4L4 31H38Z"
        fill="#60A5FA"
      />
      <path
        d="M0 10C0 7.79086 1.79086 6 4 6H38C40.2091 6 42 7.79086 42 10V28C42 30.2091 40.2091 32 38 32H4C1.79086 32 1.22392e-06 30.2091 1.22392e-06 28L0 10Z"
        fill="#93C5FD"
      />
      <path
        d="M38 31V32H4L4 31H38ZM41 28V10C41 8.34315 39.6569 7 38 7H4C2.34315 7 1 8.34315 1 10L1 28C1 29.6569 2.34315 31 4 31L4 32L3.79395 31.9951C1.68056 31.8879 1.22392e-06 30.14 1.22392e-06 28L0 10C0 7.79086 1.79086 6 4 6H38C40.2091 6 42 7.79086 42 10V28C42 30.2091 40.2091 32 38 32V31C39.6569 31 41 29.6569 41 28Z"
        fill="#60A5FA"
      />
      <g filter="url(#filter0_ii_19790_3253)">
        <path
          d="M22 24.5C22 23.6716 22.6716 23 23.5 23H26.5C27.3284 23 28 23.6716 28 24.5V25C28 25.1822 28 25.353 28 25.5002C28 25.7763 27.7761 26 27.5 26H22C22 26 22 25.5523 22 25V24.5Z"
          fill="#60A5FA"
        />
        <path
          d="M23.5 21.5C23.5 20.6716 24.1716 20 25 20C25.8284 20 26.5 20.6716 26.5 21.5C26.5 22.3284 25.8284 23 25 23C24.1716 23 23.5 22.3284 23.5 21.5Z"
          fill="#60A5FA"
        />
        <path
          d="M18 24.5C18 23.6716 18.6716 23 19.5 23H22.5C23.3284 23 24 23.6716 24 24.5V25C24 25.1822 24 25.353 24 25.5002C24 25.7763 23.7761 26 23.5 26H18C18 26 18 25.5523 18 25V24.5Z"
          fill="#60A5FA"
        />
        <path
          d="M19.5 21.5C19.5 20.6716 20.1716 20 21 20C21.8284 20 22.5 20.6716 22.5 21.5C22.5 22.3284 21.8284 23 21 23C20.1716 23 19.5 22.3284 19.5 21.5Z"
          fill="#60A5FA"
        />
        <path
          d="M14 24.5C14 23.6716 14.6716 23 15.5 23H18.5C19.3284 23 20 23.6716 20 24.5V25C20 25.5523 20 26 20 26H14.5C14.2239 26 14 25.7763 14 25.5002C14 25.353 14 25.1822 14 25V24.5Z"
          fill="#60A5FA"
        />
        <path
          d="M15.5 21.5C15.5 20.6716 16.1716 20 17 20C17.8284 20 18.5 20.6716 18.5 21.5C18.5 22.3284 17.8284 23 17 23C16.1716 23 15.5 22.3284 15.5 21.5Z"
          fill="#60A5FA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2646 12.2044C24.5659 12.4886 24.5798 12.9633 24.2956 13.2646L20.5229 17.2646C20.2469 17.5572 19.7892 17.58 19.4855 17.3163L17.7582 15.8163C17.4455 15.5447 17.4121 15.071 17.6837 14.7582C17.9553 14.4455 18.429 14.4121 18.7418 14.6837L19.9256 15.7118L23.2044 12.2354C23.4886 11.9341 23.9633 11.9202 24.2646 12.2044Z"
          fill="#60A5FA"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_19790_3253"
          x="14"
          y="12"
          width="14"
          height="15"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_19790_3253"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_19790_3253"
            result="effect2_innerShadow_19790_3253"
          />
        </filter>
      </defs>
    </svg>
  )
}
